import { Component, OnInit } from '@angular/core';
import {SendCalculationDialogComponent} from '../../dialogs/send-calculation-dialog/send-calculation-dialog.component';
import {Ga4OffersElementKey} from '../../../../core/consts/ga4-offers-element-key.enum';
import {MatDialog} from '@angular/material';
import {SendCalculationEmailService} from '../../../../core/services/impl/send-calculation-email.service';
import {Ga4EventsConfigService} from '../../../../core/services/ga4-events-config.service';
import {isNestBank} from '../../../../core/utils/utils';

@Component({
  selector: 'app-next-send-offer',
  templateUrl: './next-send-offer.component.html',
  styleUrls: []
})
export class NextSendOfferComponent implements OnInit {

  buttonLabel: string;

  constructor(private dialog: MatDialog,
              private sendCalculationEmailService: SendCalculationEmailService,
              private ga4EventsService: Ga4EventsConfigService) { }

  ngOnInit() {
    this.initButtonLabel();
  }

  mailOffer() {
    this.dialog.open(SendCalculationDialogComponent);
    if (this.sendCalculationEmailService.isOffersStep) {
      this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.SEND_CALCULATION_INIT);
    }
  }

  private initButtonLabel(): void {
    this.buttonLabel = isNestBank() ? 'HEADER.SEND_OFFER.MAIL' : 'HEADER.SEND_OFFER.MAIL_OFFER';
  }

}
